import { makeStyles } from "e100-react-components";

export const useStyles = makeStyles(({ typography, spacing, palette }) => ({
  tooltip: {
    position: "relative",
    "&::before": {
      content: '""',
      display: "inline-block",
      position: "absolute",
      left: -spacing(1),
      top: spacing(0.25),
      width: 2,
      height: "80%",
      backgroundColor: palette.secondary.light,
    },
  },
  root: {
    backgroundColor: "transparent",
    padding: 0,
    minHeight: "20px",
    "& svg": {
      visibility: "hidden",
    },
    "&:hover": {
      backgroundColor: "#ffffff",
      color: palette.primary.main,
      boxShadow: "none",
      "& svg": {
        visibility: "visible",
      },
    },
    "&:active": {
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },
  label: {
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    gap: `0 ${spacing(0.5)}px`,
  },
}));
